(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/common/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/common/assets/javascripts/constants.js');
"use strict";


const MenuTabTypes = {
  BingoLobby: 'spela',
  BingoArticles: 'articles',
  BingoSchool: 'bingoSchool',
  BingoChatSchedule: 'chatSchedule',
  Widget: 'widgetyta'
};
const StaticWidgetArea = {
  BingoLobbyTickerArea: 'bingoWidgetArea_lobby_tickerArea',
  BingoLobby: 'bingoWidgetArea_lobby',
  BingoChatSchedule: 'bingoWidgetArea_chatSchedule'
};
const BingoLogotypeLetters = ['letter-b', 'letter-i', 'letter-n', 'letter-g', 'letter-o'];
const GameRoomStatus = {
  OPEN: 'OPEN',
  STARTING: 'STARTING',
  CLOSED: 'CLOSED'
};
const PlayMode = {
  Single: 'SINGLEUSER',
  Multi: 'MULTIUSER'
};
const toExport = {
  MenuTabTypes,
  StaticWidgetArea,
  BingoLogotypeLetters,
  GameRoomStatus,
  PlayMode
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.bingo_react.components.common.constants', toExport);
}

 })(window);